import React from "react";
import { getMonthYear } from "../../../utils/dateUtils";

/**
 * MonthSelector component for selecting a month
 * @param {Object} props
 * @param {Date} props.selectedMonth - The currently selected month
 * @param {Function} props.onMonthChange - Function to call when month changes
 */
const MonthSelector = ({ selectedMonth, onMonthChange }) => {
  const handlePreviousMonth = () => {
    const prevMonth = new Date(selectedMonth);
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    onMonthChange(prevMonth);
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(selectedMonth);
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    onMonthChange(nextMonth);
  };

  return (
    <div className="month-selector">
      <button className="month-button" onClick={handlePreviousMonth}>
        &lt;
      </button>
      <h2 className="month-title">
        {getMonthYear(selectedMonth)}
      </h2>
      <button className="month-button" onClick={handleNextMonth}>
        &gt;
      </button>
    </div>
  );
};

export default MonthSelector;
